import axios from 'axios'

export const API = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
})

/*
  APIIntr | Using only for building pages
*/
export const APIIntr = axios.create({
  baseURL: process.env.API_INTR_URL,
  withCredentials: true,
})
